import deepmerge from 'deepmerge';
import { ENVIRONMENT_GLOBAL } from '../global_env';

export const environment = deepmerge(ENVIRONMENT_GLOBAL, {
  envName: 'dev',
  production: true,
  matomoSrc: '',
  redirect: {
    host: 'https://dev-oms-admin.meinhplus.de'
  },
  files: {
    paths: {
      host: 'https://dev.meinhplus.de'
    }
  },
  links: {
    applications: {
      mh2: 'https://dev.meinhplus.de',
      hcp: 'https://dev-dashboard.meinhplus.de',
      l2: 'https://dev-administration.meinhplus.de'
    }
  },
  auth_L1: {
    client_id: 'oms-tool-support',
    scope: 'phone email profile openid',
    endpoint: {
      host: 'https://dev-account.meinhplus.de',
      paths: {
        prefix: '/auth/realms/hekatron-tuer-tor'
      }
    }
  },
  backend: {
    scope: 'oms',
    client_id: 'oms-adminapp-bT8qL2fDn9Wp3JrY',
    endpoint: {
      host: 'https://api.dev-oms.meinhplus.de'
    }
  }
});
